<template>
  <div class="wrap">
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <img src="../assets/images/FoundWinners.jpg" class="wrap_img">
    <div class="winner_title">
      <van-row>
        <van-col span="6">
          <a href="javascript:void(0);" @click="getCode(1)">
            <div class="winner_flag">
              <img src="../assets/images/dxb.png">
            </div>
          </a>

        </van-col>
        <van-col span="6">
          <a href="javascript:void(0);" @click="getCode(2)">
            <div class="winner_flag">
              <img src="../assets/images/nrng.png">
            </div>
          </a>

        </van-col>
        <van-col span="6">
          <a href="javascript:void(0);" @click="getCode(3)">
            <div class="winner_flag">
              <img src="../assets/images/wcs.png">
            </div>
          </a>

        </van-col>
        <van-col span="6">
          <a href="javascript:void(0);" @click="getCode(4)">
            <div class="winner_flag">
              <img src="../assets/images/wpjm.png">
            </div>
          </a>

        </van-col>
      </van-row>
    </div>
    <div class="found_winner">
      <div class="stock_list">
        <van-row>
          <van-col span="6">
            <div class="stock_name">最新股票池</div>
          </van-col>
          <van-col span="6" :offset="12">
            <div class="more">
              <van-button round  size="mini" type="default" @click="isLogin('stock_today')">更多</van-button>
            </div>
          </van-col>
        </van-row>
        <div class="found_winner_title">
          <van-row>
            <van-col span="6">
              <h4>股票名</h4>
            </van-col>
            <van-col span="6">
              <h4>关注价</h4>
            </van-col>
            <van-col span="6">
              <h4>最高价</h4>
            </van-col>
            <van-col span="6">
              <h4>最大涨幅</h4>
            </van-col>
          </van-row>
        </div>
        <div class="found_winner_list" v-for="(item,index) in stock_today.slice(0 , 3)" :key="index">
          <van-row>
            <van-col :span="6">
              <div class="stock_name">
                <p v-if="$store.state.loginType">{{ item.stock_name }}</p>
                <p v-if="$store.state.loginType">{{ item.stock_code }}</p>
                <router-link to="/registered" v-else style="color: white">
                  <p >注册登陆可读</p>
                </router-link>

              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p> {{ item.focus_price }}</p>
                <p>{{ item.focus_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p> {{ item.high_price }}</p>
                <p>{{ item.high_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details red" v-if="item.stock_status != 1">{{ (Number(item.changepercent)*100).toFixed(2) }}%</div>
              <div class="stock_details red" v-else>- -</div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="stock_list">
        <van-row>
          <van-col :span="6">
            <div class="stock_name">近15日涨幅排行榜</div>
          </van-col>
          <van-col :span="6" :offset="12">
            <div class="more">
              <van-button round  size="mini" type="default" @click="isLogin('stock_history')" >更多</van-button>
            </div>
          </van-col>
        </van-row>
        <div class="found_winner_title">
          <van-row>
            <van-col :span="6">
              <h4>股票名</h4>
            </van-col>
            <van-col :span="6">
              <h4>关注价</h4>
            </van-col>
            <van-col :span="6">
              <h4>最高价</h4>
            </van-col>
            <van-col :span="6">
              <h4>最大涨幅</h4>
            </van-col>
          </van-row>
        </div>
        <div class="found_winner_list" v-for="(item,index) in stock_history.slice(0 , 5)" :key="index">
          <van-row>
            <van-col :span="6">
              <div class="stock_name">
                <p>{{ item.stock_name }}</p>
                <p>{{ item.stock_code }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p> {{ item.focus_price }}</p>
                <p class="van-ellipsis">{{ item.focus_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details">
                <p> {{ item.high_price }}</p>
                <p class="van-ellipsis">{{ item.high_time }}</p>
              </div>
            </van-col>
            <van-col :span="6">
              <div class="stock_details red" v-if="item.stock_status != 1">{{ (Number(item.changepercent)*100).toFixed(2) }}%</div>
              <div class="stock_details red" v-else>- -</div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <van-popup v-model="stock_today_status" class="stockPopup" closeable >
      <h3 style="padding-left: 10px;">最新股票池</h3>
      <div class="stock_more">
        <table class="stock_th" cellspacing="0" cellpadding="0" border="0">
          <tr >
            <th>股票名</th>
            <th>关注价</th>
            <th>最高价</th>
            <th>最大涨幅</th>
          </tr>
          <tr v-for="(item,index) in stock_today" :key="index" class="stock_td">
            <td>
              <p>{{ item.stock_name }}</p>
              <p>{{ item.stock_code }}</p>
            </td>
            <td>
              <p> {{ item.focus_price }}</p>
              <p>{{ item.focus_time }}</p>
            </td>
            <td>
              <p> {{ item.high_price }}</p>
              <p>{{ item.high_time }}</p>
            </td>
            <td>
              <p v-if="item.stock_status != 1">{{ (Number(item.changepercent)*100).toFixed(2) }}%</p>
              <p v-else>- -</p>
            </td>
          </tr>
        </table>
      </div>



    </van-popup>
    <van-popup v-model="stock_history_status" class="stockPopup" closeable>
      <h3 style="padding-left: 10px;">近15日涨幅排行榜</h3>
      <div class="stock_more">
        <table class="stock_th" cellspacing="0" cellpadding="0" border="0">
          <tr >
            <th>股票名</th>
            <th>关注价</th>
            <th>最高价</th>
            <th>最大涨幅</th>
          </tr>
          <tr v-for="(item,index) in stock_history" :key="index" class="stock_td">
            <td>
              <p>{{ item.stock_name }}</p>
              <p>{{ item.stock_code }}</p>
            </td>
            <td>
              <p> {{ item.focus_price }}</p>
              <p>{{ item.focus_time }}</p>
            </td>
            <td>
              <p> {{ item.high_price }}</p>
              <p>{{ item.high_time }}</p>
            </td>
            <td>
              <p v-if="item.stock_status != 1">{{ (Number(item.changepercent)*100).toFixed(2) }}%</p>
              <p v-else>- -</p>
            </td>
          </tr>
        </table>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "FoundWinners",
    data(){
      return{
        stock_today: [],
        stock_today_status: false,
        stock_history: [],
        stock_history_status: false,
        activeColor: 'red'
      }
    },
    methods:{
      getCode(classify) {
        let that = this;
        that
          .$http({
            url: "/",             //请求地址
            method: "post",
            data: {
              'nozzle': 'found_winner',
              'action': 'found_winner',
              'classify': classify,
            }
          })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              let data = resData.data;
              let stock_today = [];
              let stock_history = [];
              for (let i = 0, len = data.length; i < len; i++) {
                switch (data[i].status) {
                  case 0:
                    stock_history.push(data[i]);
                    break;
                  case 1:
                    stock_today.push(data[i]);
                    break
                }
              }
              that.stock_today = stock_today;
              that.stock_history = stock_history;
            } else {
            }
          });
      },
      isLogin(type){
        let that = this;
        if (this.$store.state.loginType){
          switch (type) {
            case 'stock_today':
              that.stock_today_status = true;
              break;
            case 'stock_history':
              that.stock_history_status = true;
              break
          }
        }else{
          that.$toast({
            message: '您还未登录,前去登录',
            type: 'error',
            onClose:function () {
              that.$router.push({
                path: "/login"
              });
            }
          });
        }
      }
    },
    mounted:function () {
      let that = this;
      that.getCode(1);
    },
    beforeDestroy() {
      // clearInterval(this.chatTimer);
    }
  }
</script>

<style scoped>
  .wrap{
    width: 100%;
    position: relative;
    /*overflow:auto;*/
  }
  .wrap_img{
    width: 100%;
    position: absolute;
    z-index: -999;
    overflow:auto;
  }
  .winner_title{
    padding-top: 170px;
  }
  .winner_flag{
    width: 90%;
    text-align: center;
    margin: 0 auto;
  }
  .winner_flag img{
    width: 30%;
    margin-top: -15px;
  }
  .found_winner{
    padding-top: 50px;
    width: 80%;
    margin: 0 auto;
  }
  .stock_name{
    height: 38px;
    text-align: center;
    background: rgb(246, 56, 56);
    border-radius: 50px;
    color: white;
    font-weight: bold;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .stock_name p{
    margin: 0;
  }
  .more {
    line-height: 40px;
    text-align: center;
  }
  .found_winner_title {
    width: 100%;
  }

  .found_winner_title h4 {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: red;
  }
  .stock_details p{
    margin: 0;
  }
  .stock_details {
    text-align: center;
    height: 38px;
    color: #333;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .found_winner_list {
    background: rgb(235, 235, 235);
    height: 38px;
    border-radius: 50px;
    margin-bottom: 8px;
    -moz-box-shadow: 5px 5px 5px #999; /* 老的 Firefox */
    box-shadow: 3px 3px 5px #999;
  }
  .found_winner_list:last-child{
    /*margin-bottom: 0;*/
  }
  .stockPopup {
    width: 90%;
  }
  .stock_more{
    width: 90%;
    margin: 0 auto;
    text-align: center;
  }
  .stock_more h4{
    font-size: 14px;
  }
  .stock_th{
    width: 100%;
  }
  .stock_td{

  }
  .stock_td td{
    border-bottom: 1px solid #999;
    padding-top: 10px;
  }
  .stock_td p{
    margin: 0;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FoundWinnersOld.vue